/**
 * Service Adresses - API Tracking
 * Endpoints:
 * - GET    /api/v1/addresses/
 * - POST   /api/v1/addresses/
 * - PUT    /api/v1/addresses/{id}/
 * - PATCH  /api/v1/addresses/{id}/
 * - DELETE /api/v1/addresses/{id}/
 */
import { createTrackingClient } from "../trackingApi";

export interface TrackingAddress {
  id: number;
  label: string;
  map_address: string | null;
  latitude: number | null;
  longitude: number | null;
  is_default: boolean;
  is_owned: boolean;
  is_assigned: boolean;
  created_at: string;
  updated_at: string;
}

export interface UpsertAddressPayload {
  label: string;
  map_address?: string | null;
  latitude?: number | null;
  longitude?: number | null;
  is_default?: boolean;
}

function getClient(accessToken: string | undefined) {
  return createTrackingClient(accessToken);
}

export async function fetchTrackingAddresses(
  accessToken: string | undefined
): Promise<TrackingAddress[]> {
  const client = getClient(accessToken);
  const { data } = await client.get<TrackingAddress[] | { results: TrackingAddress[] }>("/api/v1/addresses/");
  if (Array.isArray(data)) return data;
  if (data && typeof data === "object" && "results" in data) return (data as { results: TrackingAddress[] }).results;
  return [];
}

export async function createTrackingAddress(
  accessToken: string | undefined,
  payload: UpsertAddressPayload
): Promise<TrackingAddress> {
  const client = getClient(accessToken);
  const { data } = await client.post<TrackingAddress>("/api/v1/addresses/", payload);
  return data;
}

export async function updateTrackingAddress(
  accessToken: string | undefined,
  id: number,
  payload: UpsertAddressPayload
): Promise<TrackingAddress> {
  const client = getClient(accessToken);
  const { data } = await client.put<TrackingAddress>(`/api/v1/addresses/${id}/`, payload);
  return data;
}

export async function patchTrackingAddress(
  accessToken: string | undefined,
  id: number,
  payload: Partial<UpsertAddressPayload>
): Promise<TrackingAddress> {
  const client = getClient(accessToken);
  const { data } = await client.patch<TrackingAddress>(`/api/v1/addresses/${id}/`, payload);
  return data;
}

export async function deleteTrackingAddress(
  accessToken: string | undefined,
  id: number
): Promise<void> {
  const client = getClient(accessToken);
  await client.delete(`/api/v1/addresses/${id}/`);
}

